// extracted by mini-css-extract-plugin
module.exports = {"box":"customerservice_box_2SgjQ","boxshadow":"customerservice_boxshadow_1kllb"};